import { render, staticRenderFns } from "./CowellGroupList.vue?vue&type=template&id=42e3ba38&"
import script from "./CowellGroupList.vue?vue&type=script&lang=js&"
export * from "./CowellGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports